<template>
  <div class="mainNoticeSetting">
    <setting-header />

    <v-divider class="mainNoticeSetting_header-divider" />
    <section class="mainNoticeSetting_body">
      <template v-if="loading">
        <skeleton-list v-for="i in 3" :key="i" />
      </template>
      <template v-for="(item, index) in noticeList">
        <div
          v-if="!loading"
          :key="`mainNoticeSetting_item-${index}`"
          v-ripple
          class="mainNoticeSetting_item"
          :class="{
            'mainNoticeSetting_item--caption': captions[item.id] !== undefined,
            'mainNoticeSetting_item--disabled': item.disabled,
          }"
          @click="navigateTo(item.to)"
        >
          <h3>
            <span class="mainNoticeSetting_title">{{ item.name }}</span>
            <span
              v-if="captions[item.id] !== undefined && !item.disabled"
              class="mainNoticeSetting_caption"
              >{{ captions[item.id] }}</span
            >
            <v-icon
              v-if="!item.disabled"
              class="mainNoticeSetting_item--icon"
              size="22"
            >
              mdi-chevron-right
            </v-icon>
          </h3>

          <span
            v-if="item.desc && !item.disabled"
            class="mainNoticeSetting_item-desc"
            >{{ item.desc }}</span
          >
        </div>
        <v-divider
          v-if="!loading"
          :key="`mainNoticeSetting_item-div-${index}`"
        />
      </template>
    </section>
    <!-- Message dialog -->
    <clip-dialog-message
      :open="!!dialogMessageText"
      :message="dialogMessageText"
      @onClose="closeDialogMessage"
    />
    <!-- ----------------- -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SettingHeader from '../SettingHeader.vue';
import ClipDialogMessage from '@/components/dialogs/ClipDialogMessage.vue';

export default {
  name: 'MainNoticeSetting',
  components: {
    SettingHeader,
    ClipDialogMessage,
  },
  data() {
    return {
      dialogMessageText: '',
    };
  },
  computed: {
    ...mapState({
      noticeSettings: (state) => state.settings.noticeSettings,
      noticeSettingsLoading: (state) => state.settings.noticeSettingsLoading,
    }),
    anyTarget() {
      return this.noticeSettings.target.some((t) => t);
    },
    noticeList() {
      return [
        {
          id: '3',
          name: '通知対象の選択',
          desc: '通知を対象とするカメラグループの選択',
          to: { name: 'settings-notice-target' },
          disabled: false,
        },
        {
          id: '1',
          name: 'プッシュ通知',
          desc: 'プッシュ通知の設定と対象項目',
          to: { name: 'settings-notice-push' },
          disabled: !this.anyTarget,
        },
        {
          id: '2',
          name: 'メール通知',
          desc: 'メール通知の設定と対象項目',
          to: { name: 'settings-notice-mail' },
          disabled: !this.anyTarget,
        },
      ];
    },
    currentUserAvatarId() {
      return this.currentAvatars ? this.currentAvatars.avatars[0].id : null;
    },
    captions() {
      return {
        1: this.noticeSettings.push[0] ? 'ON' : 'OFF',
        2: this.noticeSettings.mail[0] ? 'ON' : 'OFF',
      };
    },
    loading() {
      return this.noticeSettingsLoading;
    },
  },
  watch: {
    dialogMessageText(val) {
      val || this.closeDialogMessage();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('settings', ['fetchDirectoryGroup']),
    async init() {
      this.fetchDirectoryGroup();
    },
    async displayDeleteMessage() {
      this.dialogMessageText = 'ユーザー情報を削除しました。';
      await this.fetchUserAvatarList();
      this.$router.replace({ query: null });
    },
    closeDialogMessage() {
      this.dialogMessageText = null;
    },
    navigateTo(to) {
      this.$router.push(to);
    },
  },
};
</script>

<style lang="scss">
.mainNoticeSetting {
  position: relative;
  height: 100%;

  &_header-divider {
    margin-top: 15px;
    border-color: #cccccc !important;
  }
  &_footer-divider {
    border-color: #cccccc !important;
  }
  &_body {
    height: calc(100% - 103px);
    overflow-y: auto;
  }
  &_caption {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: right;
    color: #989898;
  }
  &_title {
  }
  &_item {
    padding: 15px 0;
    cursor: pointer;
    &--caption {
      .mainNoticeSetting_title {
        display: inline-block;
        width: 220px;
      }
    }
    &--disabled {
      pointer-events: none;
      .mainNoticeSetting_title {
        color: #ccc;
      }
    }
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &-desc {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
    }
    &--icon {
      color: #c1c1c1 !important;
      line-height: 0;
    }
  }
  &_menu {
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
    background-color: #fff;
    &-icon {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      &.v-btn.v-size--default {
        font-size: 15px;
      }
    }
    &-list.v-list {
      padding: 0;

      width: 170px;
      .v-list-item__title {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #666;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
